import React, { useEffect, useState } from 'react'
import { postActualizarProcirLiquidacionQx, postDeleteTMPTMPLiquidacionQx, postInformacionEmpresa, postInsertDataTMPFAC1 } from '../../../services/PaginaRuta';
import Loading from '../../Loading';
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalPDFPaqueteLiquidacion from './ModalPDFPaqueteLiquidacion';

const ModalConfirmarLiquidacionPaquete = ({arrayProcedimientos, dataUser, dataPDF,complicacionesDx, setmodalOnConfirmarLiquidacionPaquete, setmodalOnPaqueteProcedimientos, setactualizarDataLiquidacion, dataPreciosPDF, totalPrecioProcedimiento}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo')); 
    const [loading,setloading]=useState(false)
    const [informacionEmpresa,setinformacionEmpresa]=useState({
        EMPCOD: "",
        EmpNit: "",
        EmpRazSoc: "",
        MCDnom: "",
        MCDpto: "",
        T2_EMPCOD: "",
    
      })  
    const handleCancelarClick = () => {
        setmodalOnConfirmarLiquidacionPaquete(false)
        }

    const handleOnclickConfirmarLiquidacion = () => {
      setTimeout(() => {
      setloading(true)
                  // let fecha = new Date();
                  // let año = fecha.getFullYear();
                  // let mes = ("0" + (fecha.getMonth() + 1)).slice(-2); // Los meses en JavaScript son base 0, así que añadimos 1
                  // let dia = ("0" + fecha.getDate()).slice(-2);
                  // let horas = ("0" + fecha.getHours()).slice(-2);
                  // let minutos = ("0" + fecha.getMinutes()).slice(-2);
                  // let segundos = ("0" + fecha.getSeconds()).slice(-2);
                  // let milisegundos = ("00" + fecha.getMilliseconds()).slice(-3); // En caso de milisegundos que sean menos de 100
                  // let fechaFormateada = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}.${milisegundos}`;

        const insertTableHonorariosProcedimientos= arrayProcedimientos.map((item)=>{
            return {
                      "TFFchP": dataUser.ProFec,
                      "TFProc": "2",              //ClasedeProcedimiento
                      "TFPerA": "7",              //Personal que atiende
                      "TFPrC1": item.CodigoProcedimiento,         //C�digoProcedimiento
                      "TFVaTP": `${item.precioPorcentajeProcedimiento}`,          ////ValorTotalServicio
                      "TFNomA": "",               //NombredequienAutoriza
                      "TFUPro": usuarioInfo.UsuarioEncriptado,     //UsuarioTramitaProcedimiento
                      "TFUVRVLR":item.CantidadUVR,            //ValorUVR
                      "TFUVRCOD":'',//item.CodigoFormaLiquidacion, //Formadeliquidaci�n//FALTALLLL
                      "TFCanpr":"1",              //CantidadSuministro ///1 FALTADANIEL
                      "TFCopa": "0",              //TipoCuotacoopago
                      "TFCoMo": "0",              //AplicaCuotaModeradora
                      "TFinte": `${item.precioPorcentajeProcedimiento}`,        //ValorUnitario, Valor total integral
                      "TFPCSO": `${item.agrupadorProcedimiento}`,           //TipodeProcedimientoQx MULT,INDV,BILA
                      "TFOpcn": "2",              //Opcion(Electiva/Trauma) RONALD
                      "TFPCodCCs": usuarioInfo.Sede,         //sede
                      "TFPCodSCC": item.CodigoSubCCosto,      //C�digo centro decosto 
                      "TFPTpoTrn": item.tipoHojaFact, //tipo de transaccion facturacion F o hoja de gasto H
                      "TFPFchReg": dataUser.ProFec, ///fecha agendo el procedimiento
                      "TFPinte": "0",             //% PorIntegral
                      "TFCodPab": dataPDF.TFcCodPab, //CodigoPabellon
                      "TFCoRecar":"N",            //El procedimiento manejar recargo S/N
                      "TFPCodEmp": usuarioInfo.Empresa,           //Empresa
                      "TFDiPr": dataUser.DiaSal,//"R100",           //Descripcion Dx Previo 
                      "TFHnrCod":item.CrgHnrCi,           //C􀀁digo Honorario // puede ir en blanco FALTALLLLL
                      "TFDiPP": dataUser.DiaSal,//"R100",           //Descripcion Dx Posterior
                      "TFPHoMe": "0",//`${item.PorcOrden / 100}` ,          //%HonorariosMedicos, FALTA
                      "MMcoM1": item.MedCod,          //C�digoMedico
                      "MECoM1": item.EspcCod,            //C�digoEspecialidad VALIDAR bases de datos
                      "TFDiCo": `${complicacionesDx? complicacionesDx.DxCompl: ""}`,               //C�digo Diag. Complicaci�n 
                      "TFVlrTot": `${item.precioTotalProcedimiento}`,        //valorTotalLiquidacionQx
                      "TFVias": item.via,              //vias 
                      "TFEspe": item.especilidadCirujano,              //Especialidad(igual/diferente) 
                      "TFNGrp": "01",             //GrupoQuirurgico
                      "TFHISCSEC": "0",           //folio FALTA
                      "TFEstaAnu1": "N",          //Estado de Anulacion Procedimientos Anulado='S', No anulado = 'N' //igual
                      "TFCodCir": dataUser.ProCirCod, //NumerodeCirugia 
                      "TFPPPCod": "",             //Codigo Programa PYP
                      "TFOrdMan": "N",            //Indicador de orden manual en cirugias mult /
                      "TFPPorIva": "0",           //Porcentaje de impuesto aplicado al procedimiento 
                      "TFPVlrSIv": `${item.precioPorcentajeProcedimiento}`,//Valor individual de procedimiento antes de impuesto
                      "TFOrdLiq": "1", //`${item.NumeroOrden}`,           //Orden de Liquidaci�n  //FALTA
                      "TFCnaqX": "1",            //Consecutivo de agrupador
                      "TFIMPPRC": "0",            //Valor individual de impuesto aplicado al procedimiento
                      "TFPCODIMPP": "",           //Codigo de impuesto que aplica al procedimiento
                      "TFAUTPRO": "",
                      "TFTipP": `${item.CodigoTipoProc}`,               //Tipo de Procedimiento
                      "TFHorP": "",
                      "TFConP": "",
                      "TFEPro": "",
                      "TFFPro": "",
                      "TFHPro": "",
                      "TFCodCam":"",
                      "ViaCod":"",
                      "TFUsuAnl":"",
                      "TFNCITA": "0",
                      "TFPorImpt": "0",
                      "TFFchAnu1": "N",
                      "TFEsParXTo": "0",
                      "TFConPr": "0",
                      "TFIndCop": "",
                      "TFCodPar": "",
                      "TFIFacPro": "",
                      "TFNumA": "",
                      "TFNumAuE": "0",
                      "TFCtvEnt": "0",
                      "TFCodCon": "",
                      "TFPCaue": "0",
                      "TFCODPQT": "",
                      "TFTIPLIQP": "",
                      "TFFINAL": "",
                      "TFCodAnuP": "",
                      "TFCodFinal": "",
                      "TFpEtEnT": "0",
                      "TFPCODHOM": "0", 
                      "TFPCNSPAQ": "0",
                      "TFPCTEPAQ": "0",
                      "TFREAPTR": "",
                      "TFANCATR": ""
            }
          })

          const dataInsertTMPFAC1 = {
            "tipoIdentificacion": dataUser.MPTDoc,
            "numIdentificacion": dataUser.MPCedu,
            "consIngreso": `${dataUser.ProCtvIn}`,
            "NumContrato": dataUser.ProEPS,
            "cantidadProcedimientos": "1",
            "datosProcQX": insertTableHonorariosProcedimientos
          }

          const actualizarProcir={
            ProEmpCod:usuarioInfo.Empresa,
            ProMCDpto:usuarioInfo.Sede,
            ProCirCod: dataUser.ProCirCod,
            ProEsta:'5'
          }

          postInsertDataTMPFAC1(dataInsertTMPFAC1).then((res)=>{
                                console.log(res.data,'insertar data TMPFAC1')
                                const DeleteTMPTMP={
                                    TmpUsr:usuarioInfo.UsuarioEncriptado,
                                    TmpCedu: dataUser.MPCedu,
                                    TmpTDoc:dataUser.MPTDoc,
                                    TmpClPr:'2'
                                  }
                  postDeleteTMPTMPLiquidacionQx(DeleteTMPTMP).then((res)=>{
                    console.log(res.data,'delete')
                      //setTimeout(() => {   
                        //setmodalOnConfirmarLiquidacion(false)
                        //handleCancelClickLiquidacion()
                        //setactualizarDataLiquidacion(dataInsert)  
                        setmodalOnConfirmarLiquidacionPaquete(false)
                        setactualizarDataLiquidacion(dataInsertTMPFAC1)
                        setmodalOnPaqueteProcedimientos(false)   
                        setloading(false)
                        //}, 1500);                                    
                        //setloading(false)
                  })
                postActualizarProcirLiquidacionQx(actualizarProcir).then((response)=>{
                  console.log(response,'actualizar procedimiento')
                })
        })
      },1000)
    }

    useEffect(()=>{
          const datosEmpresa={
            "EMPCOD":usuarioInfo.Empresa,
            "MCDpto":usuarioInfo.Sede
         }
            postInformacionEmpresa(datosEmpresa).then((res)=>{ 
              if(res.data[0]){
                setinformacionEmpresa(res.data[0])
                console.log(res.data,'datos empresaa')
              }
              
            })
        },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        {
          loading?
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Guardando Liquidación              
            </h5>
            
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="text-center py-4"><Loading/></div>
            </div>
          </div>
          :
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Confirmar
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  La Liquidación Paquete de Cirugía es correcta?
                </label>
              </div>
            </div>
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
             {/* <PDFDownloadLink document={<ModalAntesDescargarPDFLiquidacionQx dataPrecios={dataPrecios} dataProcedimientos={dataProcedimientos} dataPDF={dataPDF} dataUser={dataUser} dataPreciosPDF={dataPreciosPDF} dataAnestesiologo={dataAnestesiologo} totalPrecioProcedimiento={totalPrecioProcedimiento} informacionEmpresa={informacionEmpresa}/> } fileName="confirmarLiquidacionllllll.pdf"> */}
             <PDFDownloadLink document={<ModalPDFPaqueteLiquidacion informacionEmpresa={informacionEmpresa} dataUser={dataUser} dataPDF={dataPDF} dataPreciosPDF={dataPreciosPDF} totalPrecioProcedimiento={totalPrecioProcedimiento}/>} fileName="PaqueteLiquidacionQx.pdf">
                <button
                type="button"
                onClick={handleOnclickConfirmarLiquidacion}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                Si
                </button>
                </PDFDownloadLink>
            {/* </PDFDownloadLink>  */}
          </div>
          </div>
        </div>
        }
        
      </div>
    </div>
  )
}

export default ModalConfirmarLiquidacionPaquete